import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import type { PlannedModule } from './manifest';

/**
 * On the roadmap. Rendered for everyone, disabled, with a badge, and never a
 * link: the owner wants the roadmap visible, and a tile that navigates to a
 * 404 is worse than one that cannot be clicked.
 */
export const marketplaceModule: PlannedModule = {
  key: 'marketplace',
  titleKey: 'modules.marketplace.title',
  descriptionKey: 'modules.marketplace.description',
  icon: StorefrontRoundedIcon,
  comingSoon: true,
};

export const financingModule: PlannedModule = {
  key: 'financing',
  titleKey: 'modules.financing.title',
  descriptionKey: 'modules.financing.description',
  icon: AccountBalanceRoundedIcon,
  comingSoon: true,
};
